


































































import { Component, Vue } from 'vue-property-decorator'
import firebase from 'firebase/app'

import VueLoading from '../components/Loading.vue'
import TextInput from '../components/TextInput.vue'

import { auth } from '../utils/firebase'

@Component({
  components: {
    VueLoading,
    TextInput,
  },
})
export default class LoginPage extends Vue {
  email = ''
  password = ''

  loading = true
  message = ''
  problem = false

  emailValidator = (answer: string) =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      answer,
    )
  passwordValidator = (answer: string) => answer.length > 5

  async mounted() {
    const user = await auth.currentUser
    if (user) this.$router.push('/profile')
    auth.onAuthStateChanged(user => {
      if (user) this.$router.push('/profile')
      else this.loading = false
    })

    if (auth.isSignInWithEmailLink(window.location.href)) {
      var email = window.localStorage.getItem('emailForSignIn')
      if (!email) {
        email = window.prompt('Please provide your email for confirmation')
      }
      await auth.signInWithEmailLink(email as string, window.location.href)
      window.localStorage.removeItem('emailForSignIn')
    }
  }

  async signInWithEmail() {
    try {
      await auth.sendSignInLinkToEmail(this.email, {
        url: window.location.href,
        handleCodeInApp: true,
      })
      window.localStorage.setItem('emailForSignIn', this.email)
      this.message = `We've sent a link to your email address. Open it on this device to sign in automatically.`
    } catch (e) {
      this.problem = true
      this.message = `There was a problem signing you in. Make sure you sign in using the same method you used to sign in first.`
      console.info(e)
    }
  }

  signInWithFacebook() {
    const provider = new firebase.auth.FacebookAuthProvider()
    try {
      if (this.email) {
        provider.setCustomParameters({
          login_hint: this.email,
        })
      }
      auth.signInWithRedirect(provider)
    } catch (e) {
      this.problem = true
      this.message = `There was a problem signing you in. Make sure you sign in using the same method you used to sign in first.`
      console.info(e)
    }
  }

  signInWithGoogle() {
    try {
      const provider = new firebase.auth.GoogleAuthProvider()
      if (this.email) {
        provider.setCustomParameters({
          login_hint: this.email,
        })
      }
      auth.signInWithRedirect(provider)
    } catch (e) {
      this.problem = true
      this.message = `There was a problem signing you in. Make sure you sign in using the same method you used to sign in first.`
      console.info(e)
    }
  }
}
